export const EVENT_DATE_TBD_TEXT = 'TBD';

const TBD_PV_EVENT_ID = 19144;

export const isEventDateTbd = (event?: { pvEventId?: number }): boolean =>
  event?.pvEventId === TBD_PV_EVENT_ID;
